An identifier to ensure that multiple ads are not created on retries.

A unique identifier needs to be generated by your software for each position profile.
The same identifier must be provided when retrying after create failures.
Your identifiers are isolated from and will not conflict with those generated by other recruitment software providers.
